import type { ErrorCode } from './codes.ts';
import type { ErrorMessage } from './messages.ts';

export class BaseError extends Error {
  code: string;
  payload: Record<string, unknown>;

  constructor(code: ErrorCode, message: ErrorMessage, payload: Record<string, unknown> = {}) {
    super(message);
    this.code = code;
    this.payload = payload;

    Object.setPrototypeOf(this, new.target.prototype);
    Error.captureStackTrace(this, this.constructor);
  }
}

export const isBaseError = (error: unknown): error is BaseError => error instanceof BaseError;
